import { MakersiteService } from '@services/makersite.service';
import { Component, inject, Input, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { History, HistoryCreator, HistoryData } from './app-history.model';
import { PerfectScrollbarConfigInterface } from 'perfect-scrollbar-angular';
import { MatCardModule } from '@angular/material/card';
import { PerfectScrollbarModule } from 'perfect-scrollbar-angular';
import { MatIconModule } from '@angular/material/icon';
import { MdsIcon, MdsIconsModule } from '@mds/icons';
import { ColorAliases, NewUiRoute, RemoveHashPipe } from '@mds/common';
import { ChipComponent } from '@mds/ui';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MenuService } from '@services/menu.service';

@Component({
  selector: 'app-history',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    PerfectScrollbarModule,
    MatIconModule,
    MdsIconsModule,
    ChipComponent,
    MatTooltipModule,
    RemoveHashPipe,
    NewUiRoute,
  ],
  templateUrl: './app-history.component.html',
  styleUrls: ['./app-history.component.scss'],
})
export class HistoryComponent implements OnChanges {
  @Input() info: any;
  data: HistoryData;
  composerRid = '';
  productName = '';
  sidepanelData: any;
  isSidePanelShow: boolean;
  config: PerfectScrollbarConfigInterface = {
    useBothWheelAxes: false,
    suppressScrollX: true,
  };

  editIcon = MdsIcon.EDIT;
  addIcon = MdsIcon.PLUS;
  userIcon = MdsIcon.USER;
  primaryColor = ColorAliases.PRIMARY;
  private menuService = inject(MenuService);
  private makersiteService = inject(MakersiteService);

  ngOnChanges() {
    if (!this.info) return;
    this.composerRid = this.info.rid;

    this.makersiteService.getComposerHistory(this.composerRid).subscribe((res) => {
      this.createData(res[0]);
      this.menuService.updateMenuItem('backToEdit', { visible: true });
      this.menuService.updateMenuItem('history', { visible: false });
    });
  }

  createData(res) {
    this.data = {};
    const createdByObj: HistoryCreator = {
      created: true,
      created_by: res.created_by,
      created_on: res.created_on ? Date.parse(res.created_on) : '',
      link: res?.created_by?.link?.url,
    };
    const allHistory: History[] = [];

    res.list.forEach((element) => {
      const changeObj: History = {
        changeRid: element.rid,
        changeDate: Date.parse(element.date),
        updated_by: element.updated_by,
        changes: [],
      };

      for (const [header, value] of Object.entries<any>(element.value)) {
        const formatChanges = (change) =>
          change &&
          Object.entries(change)
            .filter(([_, v]) => v)
            .map(([k, v]) => `${k.replace(/[@_]/, '')}: ${v}`);

        if (value?.diff) {
          changeObj.changes.push({
            header,
            diff: value.diff.split('\n'),
            change: formatChanges(value.change),
          });
        } else if (typeof value === 'object') {
          Object.entries<any>(value).forEach((entry) => {
            changeObj.changes.push({
              header: entry[0],
              diff: entry[1].diff?.split('\n'),
              change: formatChanges(entry[1].change),
            });
          });
        }
      }
      allHistory.push(changeObj);
    });

    this.data.createProduct = createdByObj;
    this.data.allHistory = allHistory;
  }
}
